import { DATE_FORMAT } from '../../../constants/service/common/utilConstants';
import moment from '../../../lib/moment';
import { SettlementByBrandForm, SettlementFilterKeys, SettlementForm } from '../types';

export const SETTLEMENT_SEARCH_PERIOD_TYPE = {
  정산_기준일: 'BASE_DATE',
  정산_예정일: 'DUE_DATE',
  정산_완료일: 'COMPLETE_DATE',
} as const;

export const SETTLEMENT_SEARCH_PERIOD_SELECT_LIST = [
  {
    id: SETTLEMENT_SEARCH_PERIOD_TYPE.정산_기준일,
    name: '정산 기준일',
  },
  {
    id: SETTLEMENT_SEARCH_PERIOD_TYPE.정산_예정일,
    name: '정산 예정일',
  },
  {
    id: SETTLEMENT_SEARCH_PERIOD_TYPE.정산_완료일,
    name: '정산 완료일',
  },
] as const;

export const SETTLEMENT_DATE_READY_BUTTON_LIST = [
  {
    id: 'TODAY',
    name: '오늘',
    unit: 'days',
    amount: 0,
  },
  {
    id: '1',
    name: '1일',
    unit: 'days',
    amount: 1,
  },
  {
    id: '2',
    name: '2일',
    unit: 'days',
    amount: 2,
  },
  {
    id: '3',
    name: '3일',
    unit: 'days',
    amount: 3,
  },
  {
    id: 'ALL',
    name: '전체',
  },
] as const;

export const SETTLEMENT_DATE_BUTTON_LIST = [
  {
    id: 'TODAY',
    name: '오늘',
    unit: 'days',
    amount: 0,
  },
  {
    id: '1',
    name: '1일',
    unit: 'days',
    amount: 1,
  },
  {
    id: '2',
    name: '2일',
    unit: 'days',
    amount: 2,
  },
  {
    id: '3',
    name: '3일',
    unit: 'days',
    amount: 3,
  },
  {
    id: '7',
    name: '7일',
    unit: 'days',
    amount: 7,
  },
  {
    id: '10',
    name: '10일',
    unit: 'days',
    amount: 10,
  },
  {
    id: '20',
    name: '20일',
    unit: 'days',
    amount: 20,
  },
  {
    id: '30',
    name: '30일',
    unit: 'days',
    amount: 30,
  },
  {
    id: '100',
    name: '100일',
    unit: 'days',
    amount: 100,
  },
  {
    id: 'ALL',
    name: '전체',
  },
] as const;

export const SETTLEMENT_PERIOD_TYPE = {
  전체: 'ALL',
  일간_정산: 'DAILY',
  월간_정산: 'MONTHLY',
} as const;

export const SETTLEMENT_PERIOD_SELECT_LIST = [
  {
    id: SETTLEMENT_PERIOD_TYPE.전체,
    name: '전체',
  },
  {
    id: SETTLEMENT_PERIOD_TYPE.일간_정산,
    name: '일간 정산',
  },
  {
    id: SETTLEMENT_PERIOD_TYPE.월간_정산,
    name: '월간 정산',
  },
] as const;

export const SETTLEMENT_PRODUCT_MANAGEMENT_TYPE = {
  입점상품: 'ENTER',
  입고상품: 'INCOME',
  위탁생산: 'CONSIGNMENT_MANUFACTURE',
} as const;

export const SETTLEMENT_BRAND_SEARCH_BOX_SELECT_LIST: readonly {
  id: SettlementByBrandForm['searchType'];
  name: string;
}[] = [
  {
    id: 'ids',
    name: '브랜드 ID',
  },
  {
    id: 'names',
    name: '브랜드 명',
  },
] as const;

export const SETTLEMENT_BRAND_LIST_PRODUCT_MANAGEMENT_TYPE_CHECKBOX_LIST = [
  {
    id: SETTLEMENT_PRODUCT_MANAGEMENT_TYPE.입점상품,
    name: '입점상품',
  },
  {
    id: SETTLEMENT_PRODUCT_MANAGEMENT_TYPE.입고상품,
    name: '입고상품',
  },
  {
    id: SETTLEMENT_PRODUCT_MANAGEMENT_TYPE.위탁생산,
    name: '위탁생산',
  },
];

export const SETTLEMENT_MONTHLY_EXECUTION_PERIOD = {
  MIN: 1,
  MAX: 12,
} as const;

export const SETTLEMENT_MONTHLY_EXECUTION_DAY = { MIN: 6, MAX: 27 } as const;

export const SETTLEMENT_FILTER_OPTION_MODEL: Record<SettlementFilterKeys, string> = {
  accountHolder: '',
  accountNumber: '',
  bankName: '',
  brandId: '',
  brandName: '',
  id: '',
};

export const SETTLEMENT_SORT_OPTION_MODEL = { sort: '' };

export const SETTLEMENT_SORT_PAGINATION_MODEL = {
  pageIndex: 1,
  pageSize: 100,
};

export const SETTLEMENT_FORM_INIT_STATE: SettlementForm = {
  searchPeriodType: SETTLEMENT_SEARCH_PERIOD_TYPE.정산_예정일,
  searchPeriodStartDate: moment().subtract(0, 'days').format(DATE_FORMAT.YMD_DASH_FORMAT),
  searchPeriodEndDate: moment().format(DATE_FORMAT.YMD_DASH_FORMAT),
  periodType: SETTLEMENT_PERIOD_TYPE.전체,
  quickDate: 'TODAY',
};

export const SETTLEMENT_BY_BRAND_FORM_INIT_STATE: SettlementByBrandForm = {
  searchType: 'ids',
  searchText: '',
  periodType: SETTLEMENT_PERIOD_TYPE.전체,
  productManagementTypes: [],
};

export const MAXIMUM_NUMBER_OF_SEARCH_BOX_BRAND_ID = 1_000;
